import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { OpenIdConnectConfigService } from "@obg/common.verification";
import { Subscription } from "rxjs";
import { filter, take, tap } from "rxjs/operators";

@Component({
	selector: "obg-m-dga-login-component",
	templateUrl: "./dga-login.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
	providers: [OpenIdConnectConfigService],
})
export class DgaLoginComponent implements OnInit, OnDestroy {
	@Input() allLinksExternal = false;
	@Input() autoFocus = false;
	@Input() errorsInAlert = false;
	@Input() hideEmailPasswordLogin = false;
	@Output() busy = new EventEmitter<boolean>();

	routeParam$$: Subscription | undefined;
	idTabText = "";
	selectedTabIndex = 1;
	mitIdEnabled = false;

	constructor(
		private route: ActivatedRoute,
		private configService: OpenIdConnectConfigService,
		private translateService: TranslateService
	) {
		this.mitIdEnabled = this.configService.getIsMitIdEnabled();
	}

	ngOnInit() {
		this.routeParam$$ = this.route.queryParams
			.pipe(
				take(1),
				filter((param) => param.openID),
				tap(() => (this.selectedTabIndex = 0))
			)
			.subscribe();

		this.setTabText();
	}

	setTabText() {
		this.idTabText = this.translateService.instant("login.type.mit-id");
	}

	ngOnDestroy(): void {
		this.routeParam$$?.unsubscribe();
	}
}
